module.exports = __webpack_public_path__ + "static/sport/game-2.71fa901.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ldp/game-2.png
// module id = TyAq
// module chunks = 0